import React from "react";
import { Folder, FileText } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { TruncatedText } from "@/components/ui/truncated-text";

interface SaveDialogProps {
  isSaveDialogOpen: boolean;
  setIsSaveDialogOpen: (open: boolean) => void;
  handleSaveToFolder: (folderId: string | null) => void;
  folders: Array<{ id: string; name: string; }>;
}

const SaveDialog: React.FC<SaveDialogProps> = ({
  isSaveDialogOpen,
  setIsSaveDialogOpen,
  handleSaveToFolder,
  folders,
}) => {
  return (
    <Dialog open={isSaveDialogOpen} onOpenChange={setIsSaveDialogOpen}>
      <DialogContent className="sm:max-w-[400px] w-[calc(100vw-40px)] max-w-[320px]">
        <DialogHeader>
          <DialogTitle>Save Journey Map</DialogTitle>
          <DialogDescription>
            Choose where to save your map
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 py-3">
          <Button onClick={() => handleSaveToFolder(null)} variant="outline" className="w-full justify-start">
            <FileText className="mr-1.5 h-4 w-4 flex-shrink-0" />
            <span className="truncate">Root (No Folder)</span>
          </Button>
          
          {folders.length > 0 && (
            <div className="text-sm font-medium">Folders:</div>
          )}
          
          {folders.map(folder => (
            <Button 
              key={folder.id} 
              onClick={() => handleSaveToFolder(folder.id)} 
              variant="outline"
              className="w-full justify-start"
            >
              <Folder className="mr-1.5 h-4 w-4 flex-shrink-0" />
              <div className="truncate flex-1 text-left">
                <TruncatedText 
                  text={folder.name} 
                  maxWidth="[200px]"
                  tooltipSide="top"
                  className="text-left"
                />
              </div>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SaveDialog;
